import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

interface Props {
  children: React.ReactNode;
  className?: string;
  id?: string;
}

const Portal: React.FC<Props> = ({ children, className = '', id = 'portal-root' }) => {
  const [container, setContainer] = useState<HTMLElement | null>(null);

  useEffect(() => {
    let el = document.getElementById(id);

    if (!el) {
      el = document.createElement('div');
      el.id = id;
      el.className = className;
      document.body.appendChild(el);
    }

    setContainer(el);

    return () => {
      if (el && el.parentNode) {
        el.parentNode.removeChild(el);
      }
    };
  }, [className, id]);

  return container ? ReactDOM.createPortal(children, container) : null;
};

export default Portal;
